export default __webpack_public_path__ + "static/media/RocrtTransIcon.6a2db82b.png";